<template>
  <v-app>
    <v-main class="login-bg">
      <v-container fluid class="fill-height pa-0">
        <v-row class="fill-height" no-gutters>

          <!-- LEFT: Branding / Photobooth vibe -->
          <v-col
            cols="12"
            md="7"
            class="hidden-sm-and-down branding justify-center align-center text-center white--text"
          >
            <div class="overlay"></div>

            <h1 class="text-h2 font-weight-bold mt-10">Live Social Feed</h1>
            <p class="text-h6 mt-3 font-weight-light">
              Capture memories. Print moments. Share joy.
            </p>

            <v-row class="mt-10" justify="center" dense>
              <v-chip class="ma-2" color="green darken-2" text-color="white">
                Instant Print
              </v-chip>
              <v-chip class="ma-2" color="green darken-1" text-color="white">
                Album Save
              </v-chip>
              <v-chip class="ma-2" color="green accent-4" text-color="white">
                HD Filters
              </v-chip>
            </v-row>
          </v-col>

          <!-- RIGHT: Login Form -->
          <v-col
            cols="12"
            md="5"
            class="login-section d-flex align-center justify-center pa-6"
          >
            <v-card class="pa-8 login-card" rounded="xl" elevation="10">

              <div class="text-center mb-8">
                <v-img src="@/assets/lsf-logo.png" height="80" contain></v-img>

                <h2 class="text-h4 font-weight-bold mt-4">Welcome!</h2>
                <p class="text-caption text--secondary">
                  Login to view and manage subscriptions, and more.
                </p>
              </div>

              <v-form @submit.prevent="login()">
                <v-text-field
                  label="Email"
                  prepend-inner-icon="mdi-email"
                  outlined
                  dense
                  class="mb-4"
                  v-model="user.email"
                />

                <v-text-field
                  label="Password"
                  type="password"
                  prepend-inner-icon="mdi-lock"
                  outlined
                  dense
                  hide-details
                  v-model="user.password"
                />

                <v-row class="align-center justify-end mt-2">

                  <a href="#" class="forgot-link">Forgot password?</a>
                </v-row>

                <v-btn
                  block
                  large
                  class="mt-6 white--text"
                  color="green darken-2"
                  type="submit"
                >
                  Login
                </v-btn>

                <div class="text-center mt-6 text-caption">
                  Don’t have an account?
                  <a href="#" class="signup-link">Sign up</a>
                </div>
              </v-form>

            </v-card>
          </v-col>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import api from '@/services/axios';
export default {
  name: "GreenPhotoboothLogin",
  data () {
    return {
      user : {}
    };
  },
  methods: {
    async login() {
      this.$store.commit('setLoading', true);
      try {
        const response = await api.post('/admin/login', this.user);
        localStorage.setItem('user', JSON.stringify(response.data));
        this.$store.commit('setUser', response.data);

        this.$router.push({ name: 'ApprovedTestimonials' });
      } catch (error) {
        alert(error.response.data.message);
      }
      this.$store.commit('setLoading', false);
    }
  }
};
</script>

<style scoped>
.login-bg {
  background: linear-gradient(135deg, #0f3d2e, #145a32);
}

.branding {
  position: relative;
  background: url("https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80");
  background-size: cover;
  background-position: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 60, 30, 0.65);
}

.login-card {
  width: 100%;
  max-width: 420px;
  backdrop-filter: blur(8px);
  background: rgba(255, 255, 255, 0.92);
}

.forgot-link,
.signup-link {
  font-size: 12px;
  color: #1b5e20;
  text-decoration: none;
}

.forgot-link:hover,
.signup-link:hover {
  text-decoration: underline;
}

@media (max-width: 767px) {
  .branding {
    max-height: 400px;
  }
  .login-section {
    background: url("https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80");
    background-size: cover;
    background-position: center;
  }
}
</style>